import { render, staticRenderFns } from "./LaboratoryEducations.vue?vue&type=template&id=9feccaac&"
import script from "./LaboratoryEducations.vue?vue&type=script&lang=js&"
export * from "./LaboratoryEducations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports